import React, { Fragment } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/input/Input/Input';
import SelectForm from '../../../../../components/form/SelectForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import CountOfTotal from '../../../../../components/CountOfTotal';
import ImgUpload from '../../../../../components/ImgUpload';
import BaseForm from '../../../../../components/form/BaseForm';
import InputForm from '../../../../../components/form/InputForm';
import {
  ORDER_ITEM_STATUS_TEXT,
  EXCHANGE_RETURN_REQUEST_TYPE_SELECT_LIST,
  ORDER_RETURN_ITEM_TYPE_SELECT_LIST,
  REJECT_DETAIL_IMG_WIDTH,
  REJECT_DETAIL_IMG_HEIGHT,
  MINIMUM_WIDTH_OF_INPUT_REJECT_DETAIL_IMG,
  MINIMUM_HEIGHT_OF_INPUT_REJECT_DETAIL_IMG,
  EXCHANGE_RETURN_REQUEST_TYPE,
} from '../../../../../constants/service/app/orderConstants';
import { addAllItemToSelectList } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { IMAGE_SIZE_GUIDE_TEXT, IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';
import './OrderItemReturnExchangeRequestModal.scss';

const OrderItemReturnExchangeRequestModal = (props) => {
  const {
    form,
    isOpen,
    data,
    closeModal,
    setData,
    imgUpload,
    onSubmit,
    requestType,
    requestReasonType,
    requestReason,
    requestAttachment,
    bankId,
    bankNumber,
    bankHolder,
  } = props;
  const { orderItemStatus, bankList } = data;

  return (
    <Modal
      title="교환/반품으로 변경"
      isOpen={isOpen}
      width={800}
      height={600}
      isFooter={true}
      okText="변경하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="order-item-return-exchange-request-modal-wrap">
        <div className="request-item change-status">
          <div className="current-order-item-status">
            <div className="title">현재</div>
            <Input value={ORDER_ITEM_STATUS_TEXT[orderItemStatus]} size="large" disabled={true} />
          </div>

          <FaArrowRight className="icon" size="40" />

          <div className="change-order-item-status">
            <div className="title">변경</div>

            <SelectForm
              name="status"
              form={form}
              rules={[formRequiredRules(true, undefined, false)]}
              list={EXCHANGE_RETURN_REQUEST_TYPE_SELECT_LIST}
              initialValue={requestType}
              onChange={(value) =>
                setData({
                  name: 'requestType',
                  value,
                })
              }
            />
          </div>
        </div>

        <SelectForm
          className="request-item"
          label={<span className="title">요청 사유</span>}
          name="requestReasonType"
          form={form}
          rules={[formRequiredRules(true, undefined, false)]}
          list={addAllItemToSelectList(ORDER_RETURN_ITEM_TYPE_SELECT_LIST, '선택')}
          initialValue={requestReasonType}
          onChange={(value) =>
            setData({
              name: 'requestReasonType',
              value,
            })
          }
        />

        <TextAreaForm
          className="request-item"
          label={
            <span>
              <span className="title">상세 사유</span>
              <CountOfTotal content={requestReason} maxCnt={200} />
            </span>
          }
          name="requestReason"
          form={form}
          rules={[formRequiredRules(true, undefined, false), { min: 5, message: '최소 5자 이상 입력해야합니다.' }]}
          initialValue={requestReason}
          onChange={(value) =>
            setData({
              name: 'requestReason',
              value,
            })
          }
          maxLength={200}
          placeholder={'변경 상세 사유를 입력해주세요.\n' + '(최소 5자/최대 200자)'}
        />

        {requestType === EXCHANGE_RETURN_REQUEST_TYPE.RETURN && Array.isArray(bankList) ? (
          <div className="request-item">
            <div>
              <div className="title">환불받으실 계좌를 입력해주세요</div>
              <div className="explain-text refund-account-explain">
                <div>은행 서버 점검시간 (23:30 ~ 00:30)</div>
                <div>은행 서버 점검시간에 포함되지 않을때 시도해주세요</div>
              </div>
            </div>

            <SelectForm
              className="refund-account-input"
              form={form}
              name="bankId"
              rules={[formRequiredRules(true, undefined, false)]}
              list={bankList}
              initialValue={bankId}
              onChange={(value) =>
                setData({
                  name: 'bankId',
                  value,
                })
              }
            />

            <InputForm
              className="refund-account-input"
              form={form}
              name="bankNumber"
              rules={[formRequiredRules(true, undefined, false)]}
              initialValue={bankNumber}
              onChange={(value) =>
                setData({
                  name: 'bankNumber',
                  value,
                })
              }
              size="large"
              placeholder="환불계좌 번호"
            />

            <InputForm
              className="refund-account-input"
              form={form}
              name="bankHolder"
              rules={[formRequiredRules(true, undefined, false)]}
              initialValue={bankHolder}
              onChange={(value) =>
                setData({
                  name: 'bankHolder',
                  value,
                })
              }
              size="large"
              placeholder="환불계좌 예금주"
            />
          </div>
        ) : undefined}

        <div className="request-item">
          <div className="caution-text">** 등록한 사진은 구매자에게 보여집니다.</div>

          <BaseForm
            className="request-image-upload"
            label={
              <Fragment>
                <span className="title">상세 사진 (옵션)</span>
                <CountOfTotal content={requestAttachment} maxCnt={3} />
              </Fragment>
            }
            content={
              <div className="detail-img">
                <ImgUpload
                  list={requestAttachment}
                  cropMode={true}
                  maxCnt={3}
                  setData={imgUpload}
                  targetPath={['requestAttachment']}
                  targetSize={{
                    width: REJECT_DETAIL_IMG_WIDTH,
                    height: REJECT_DETAIL_IMG_HEIGHT,
                  }}
                  restriction={{
                    widthMin: MINIMUM_WIDTH_OF_INPUT_REJECT_DETAIL_IMG,
                    heightMin: MINIMUM_HEIGHT_OF_INPUT_REJECT_DETAIL_IMG,
                  }}
                  name="requestAttachment"
                />

                {/*사진이 등록되지 않았을때만 가이드 문구를 보이게 한다.*/}
                {!requestAttachment.length ? (
                  <div className="explain-text">
                    <div>*비율 가로1:세로1</div>
                    <div>*최소 크기: 800 x 800 px (권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
                    <div>*{IMAGE_SIZE_GUIDE_TEXT}</div>
                    <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
                    <div>*상세 이미지는 최대 3개까지 저장할 수 있습니다.</div>
                  </div>
                ) : undefined}
              </div>
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default OrderItemReturnExchangeRequestModal;
